"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Check = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var helios_styles_1 = require("@carvana/helios-styles");
var Check = function (_a) {
    var _b = _a.size, size = _b === void 0 ? 24 : _b, _c = _a.color, color = _c === void 0 ? helios_styles_1.icon.default : _c;
    return ((0, jsx_runtime_1.jsx)("svg", __assign({ width: size, height: size, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: (0, jsx_runtime_1.jsx)("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M14 4C14.2604 4.26035 14.2604 4.68246 14 4.94281L7.13809 11.8047C6.87774 12.065 6.45563 12.065 6.19528 11.8047L2.86195 8.47135C2.6016 8.211 2.6016 7.78889 2.86195 7.52854C3.1223 7.26819 3.54441 7.26819 3.80476 7.52854L6.66669 10.3905L13.0572 4C13.3176 3.73965 13.7397 3.73965 14 4Z", fill: color }) })));
};
exports.Check = Check;
